var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWishlist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h32v32H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.32 7.02c-1.12-1.12-2.51-1.68-4.15-1.68-1.22 0-2.34.32-3.35.95-1.01.63-1.95 1.59-2.82 2.88-.8-1.24-1.72-2.19-2.77-2.85s-2.18-.98-3.4-.98c-1.64 0-3.03.56-4.15 1.68S4 9.54 4 11.2c0 .87.17 1.74.5 2.63.33.89.93 1.89 1.78 3.02.86 1.12 2.01 2.41 3.45 3.87 1.44 1.46 3.28 3.21 5.5 5.25l.77.7.77-.7c2.22-2.04 4.06-3.8 5.52-5.27 1.46-1.47 2.61-2.76 3.45-3.87.84-1.11 1.43-2.11 1.77-3 .33-.89.5-1.77.5-2.63 0-1.67-.56-3.06-1.68-4.18Zm.17 6.62c-.32.82-.9 1.76-1.73 2.82-.83 1.06-1.96 2.29-3.37 3.72-1.41 1.42-3.21 3.13-5.38 5.13-2.18-2-3.98-3.71-5.4-5.12-1.42-1.41-2.54-2.65-3.37-3.72-.82-1.07-1.39-2.01-1.72-2.83a6.65 6.65 0 0 1-.48-2.43c0-1.4.46-2.56 1.38-3.47.92-.91 2.06-1.37 3.42-1.37 1.11 0 2.13.33 3.07.98s1.82 1.67 2.67 3.05h.87c.82-1.38 1.7-2.39 2.63-3.05.93-.66 1.97-.98 3.1-.98 1.38 0 2.52.46 3.43 1.37s1.37 2.07 1.37 3.47c0 .8-.16 1.61-.48 2.43Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlist);
export default __webpack_public_path__ + "static/media/Wishlist.2ba7d89f45935f8a72241bec24d08f6b.svg";
export { ForwardRef as ReactComponent };